import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "capitalize",
})
// This pipe capitalizes the first letter of a string and converts the rest to lowercase
// Examples:
// "hELLo wORLD" -> "Hello world"
// "JOHN" -> "John"
// "mary" -> "Mary"
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return "";

    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
